import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dixa = defineConnector({
  identifier: "dixa",
  name: "Dixa",
  tagLine: "Conversational customer service platform",
  logo,
  protocol: "http",
  tags: ["communication", "productivity"],
  defaultUrlPattern: () => "https://dev\\.dixa\\.io/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create a Dixa API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Dixa, go to **Settings > Integrations > API Tokens**, create a token for the Dixa API, and copy it before leaving the page.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://dev.dixa.io/v1/organization",
  },
});
